import dnd from "./dnd.svg";
import idle from "./idle.svg";
import offline from "./offline.svg";
import online from "./online.svg";
import stream from "./stream.svg";

export default { dnd, idle, offline, online, stream };
